export default "__VITE_ASSET__RbHSwWvB__"